import * as React from 'react';
import { Modal, UIHeading1 } from '@cian/ui-kit';
import { CPDModalContent } from '../../components/CPDModal';
import { useDispatch, useSelector } from 'react-redux';
import { selectCpdLandingSaleUrl, selectCpdLandingSaleToBuyUrl, selectCpdLandingBuyUrl } from '../../selectors/cpd';
import { selectIsCPDModalOpen } from '../../selectors/cpd/selectIsCPDModalOpen';
import { setCpdModalOpen } from '../../actions/cpd/actions';
import { trackPopupItemClick } from './tracking';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';
import { TThunkDispatch } from '../../types/redux';

export const CPDModalContainer: React.FC = () => {
  const isOpen = useSelector(selectIsCPDModalOpen);
  const cpdLandingSaleUrl = useSelector(selectCpdLandingSaleUrl);
  const cpdLandingSaleToBuyUrl = useSelector(selectCpdLandingSaleToBuyUrl);
  const cpdLandingBuyUrl = useSelector(selectCpdLandingBuyUrl);

  const dispatch = useDispatch<TThunkDispatch>();

  const handleClose = React.useCallback(() => {
    dispatch(setCpdModalOpen(false));
  }, [dispatch]);

  const handleSaleClick = React.useCallback(() => {
    trackPopupItemClick('tab_realtor_sale', 'sell');
    window.open(cpdLandingSaleUrl as string, '_self');
  }, [cpdLandingSaleUrl]);

  const handleBuyClick = React.useCallback(() => {
    trackPopupItemClick('tab_realtor_buy', 'buy');
    window.open(cpdLandingBuyUrl as string, '_self');
  }, [cpdLandingBuyUrl]);

  const handleSaleToBuyClick = React.useCallback(() => {
    trackPopupItemClick('tab_realtor_sale_to_buy', 'sell');
    window.open(cpdLandingSaleToBuyUrl as string, '_self');
  }, [cpdLandingSaleToBuyUrl]);

  const handleRentClick = React.useCallback(() => {
    trackPopupItemClick('tab_realtor_rent');
    window.open('https://www.cian.ru/pik-arenda/ ', '_self');
  }, []);

  const handleOtherClick = React.useCallback(() => {
    trackPopupItemClick('tab_realtor_other');
    window.open('https://www.cian.ru/podbor-rieltora/', '_self');
  }, []);

  if (!cpdLandingSaleUrl || !cpdLandingSaleToBuyUrl || !cpdLandingBuyUrl) {
    return null;
  }

  return (
    <Modal
      size="S"
      open={isOpen}
      closeButtonProps={{ theme: 'fill_light', title: 'Закрыть', icon: <IconActionClose16 /> }}
      onOpenChange={handleClose}
      header={<UIHeading1 color="text-primary-default">С чем нужна помощь риелтора?</UIHeading1>}
      body={
        <CPDModalContent
          onSaleClick={handleSaleClick}
          onBuyClick={handleBuyClick}
          onSaleToBuyClick={handleSaleToBuyClick}
          onRentClick={handleRentClick}
          onOtherClick={handleOtherClick}
        />
      }
      footer={<div />}
    />
  );
};
